module.exports = __webpack_public_path__ + "assets/img/agriculture.d5d93780.png";